<template>
    <div>
        <div class="row col-12 m-0 px-0 d-flex justify-content-between">
            <h4 class="font-weight-bold">Anexo</h4>
            <div class="">
                <button
                    class="btn px-1 py-0 btn-primary"
                    @click="$bvModal.show('create-pasta')"
                >
                    <i class="mdi mdi-18px mdi-folder-plus"></i>
                    Criar Pasta
                </button>
                <button
                    class="btn px-1 py-0 btn-primary"
                    @click="$bvModal.show('upload')"
                >
                    <i class="mdi mdi-18px mdi-folder-upload"></i> Enviar
                    Arquivo
                </button>
                <button
                    class="btn px-1 py-0 btn-primary"
                    @click="listView = 'grid'"
                >
                    <i class="mdi mdi-18px mdi-view-grid"></i>
                </button>
                <button
                    class="btn px-1 py-0 btn-primary"
                    @click="listView = 'list'"
                >
                    <i class="mdi mdi-18px mdi-view-list"></i>
                </button>
            </div>
        </div>

        <div class="row m-0 py-2" @contextmenu="handler($event)">
            <form-input-group
                placeholder="Digite o nome da pasta ou arquivo que deseja buscar"
                icon-btn="mdi mdi-magnify"
                btn-class="btn-primary"
                class="px-0"
                @submit="buscar"
                v-model="search"
            />

            <div class="col-md-3 border-right px-0">
                <div class="box-tree">
                    <Arvore
                        :pastas-arvore="arquivosTemp.arvore"
                        :root-name="arquivosTemp.nome"
                        :root-pasta="pathRoot"
                        :path-current="pathCurrent"
                        :selected-pasta-box="pastaSelected"
                        @caminhoSelected="openFolder"
                        @pastaSelected="setPastaSelected"
                        @load="openFolder"
                        @root="openFolder"
                    />
                </div>
            </div>

            <div class="col-md-9 px-0" v-if="loadFiles">
                <load mode="table" />
            </div>

            <div v-else class="col-md-9 pr-0 pl-2">
                <Breadcrumb @selected="openFolder" :path-current="pathCurrent" />

                <ViewGrid
                    v-if="listView == 'grid'"
                    :arquivos="diretorios"
                    @open="openFolder"
                    @view="viewFile"
                    @deletar="deleteFile"
                    @renomear="OpenRenomear"
                />

                <ViewList
                    v-if="listView == 'list'"
                    :arquivos="diretorios"
                    @open="openFolder"
                    @view="viewFile"
                    @deletar="deleteFile"
                    @renomear="OpenRenomear"
                />
            </div>
        </div>

        <ModalNovaPasta :path="pathCurrent" @addpasta="loadAll" />

        <ModalUpload
            :path="pathCurrent"
            :path-root="pathRoot"
            :item="item"
            @upload-completed="getFiles"
        />

        <ModalView :anexo="anexoSelected" />

        <ModalRenomear
            :path="pathCurrent"
            :item="anexoSelected"
            @reload="loadAll"
        />

        <!-- MODAL AVISO -->
        <b-modal id="pasta-aviso" title="Aviso" hide-footer>
            <p>
                O conteúdo desta pasta não pode ser exibido aqui.
            </p>

            <div class="text-right">
                <button class="btn btn-primary" @click="confirmRedirect">
                    Ciente
                </button>
            </div>
        </b-modal>

    </div>
</template>

<script>

import Breadcrumb from "./includes/Breadcrumb";
import Arvore from "./includes/Arvore";
import ViewGrid from "./includes/ViewGrid";
import ViewList from "./includes/ViewList";
import ModalNovaPasta from "./includes/ModalNovaPasta";
import ModalUpload from "./includes/ModalUpload";
import ModalView from "./includes/ViewArquivo";
import ModalRenomear from "./includes/ModalRenomear";

export default {

    components: {
        Arvore,
        Breadcrumb,
        ViewList,
        ViewGrid,
        ModalNovaPasta,
        ModalUpload,
        ModalView,
        ModalRenomear,
    },

    props: ["item", "path"],

    data() {
        return {
            pastas_selected: "",
            search: "",
            anexoSelected: "",
            listView: "grid",
            arquivos: [],
            arvore: [],
            arquivosTemp: [],
            loadFiles: true,
            pathRoot: "",
            pathCurrent: "",
            pastaSelected: null,

            pastaBloqueadas: [
                "Atendimentos",
                "Acolhimentos",
                "Encaminhamentos",
                "Referenciamentos",
                "Violacaodedireitos"
            ],

            
            isBlocked: false,
            blockedMessage: "",
        };
    },

    mounted() {
        this.pathRoot = this.path;
        this.pathCurrent = this.path;
        this.getFolders(this.pathCurrent);
    },

    computed: {
        diretorios() {

            if (!this.arquivos.pastas) return [];

            return this.arquivos.pastas.filter((item) => {

                if (this.isPathBloqueado(item.nome)) return false;

                if (this.search != "") {
                    return item.nome
                        .toLowerCase()
                        .includes(this.search.toLowerCase());
                }

                return true;
            });
        },
    },

    methods: {

        //verifica bloqueio por path/nome
        isPathBloqueado(path = "") {

            const lower = (path || "").toLowerCase();

            return this.pastaBloqueadas.some((bloqueada) =>
                lower.includes(bloqueada.toLowerCase())
            );
        },

        //ativa bloqueio
        bloquearAcessoPasta() {

            this.isBlocked = true;
            this.blockedMessage = "O conteúdo desta pasta está bloqueado.";

            swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: "Você será redirecionado para o módulo correspondente para visualizar o arquivo.",
                
                confirmButtonText: "Ciente",
                confirmButtonColor: "#2f6fb2",

                cancelButtonText: "Fechar",
                cancelButtonColor: "#6c757d",
                showCancelButton: true,

                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {

                if (result.isConfirmed) {
                    this.redirectFromBlocked(this.pathCurrent);
                }

                
                if (result.isDismissed) {
                    return;
                }
            });

        },

        getIdFromPath(path = "") {

            const match = path.match(/(\d+)(?!.*\d)/); 
            return match ? match[1] : null;
        },

        redirectFromBlocked(path = "") {

            const id = this.getIdFromPath(path);

            if (!id) return;

            const lower = path.toLowerCase();

            let route = "/dashboard";

            if (lower.includes("atendimentos")) {
                route += `/atendimentos/${id}`;
            }

            else if (lower.includes("acolhimentos")) {
                route += `/familia/acolhimentos/${id}?familia_id=${id}`;
            }

            else if (lower.includes("encaminhamentos")) {
                route += `/encaminhamentos/${id}?familia_id=${id}`;
            }

            else if (lower.includes("referenciamentos")) {
                route += `/referenciamentos/${id}?familia_id=${id}`;
            }

            else if (lower.includes("violacaodedireitos")) {
                route += `/violacaodedireitos/${id}?familia_id=${id}`;
            }

            else {
                route += `/atendimentos/${id}`;
            }

            
            route = route
                .replace(/api\/dashboard\/[^/]+\//g, "")
                .replace(/storage\/uploads\/filemanager\/[^/]+\//g, "");

            this.$router.push(route);
        },

        //libera visualização
        clearBlock() {
            this.isBlocked = false;
            this.blockedMessage = "";
        },

        setPastaSelected(pasta) {
            this.pastaSelected = pasta;
        },

        viewFile(anexo) {

            if (anexo.tipo != "pasta") {
                this.anexoSelected = anexo;
                this.$bvModal.show("view-file");
            }
        },

        //abrir pasta com proteção
        openFolder(item) {

            const path = item.caminho || item.nome || "";

            this.getFiles(item);
        },

        loadAll(path = null) {
            this.getArvore();
            this.getFiles(path ?? this.pathCurrent);
        },

        getFilesPathRoot() {
            axios
                .post(`api/dashboard/get/arquivos`, {
                    path: this.pathRoot || "/",
                })
                .then((response) => {
                    this.arquivosTemp = response.data;
                });
        },

        //FUNÇÃO PRINCIPAL
        getFiles(item) {

            const path = item?.caminho ? item.caminho : item;

            this.pathCurrent = path;

            //BLOQUEIO ANTES DA REQUISIÇÃO
            if (this.isPathBloqueado(path)) {
                this.bloquearAcessoPasta();
                return;
            }

            this.clearBlock();

            this.loadFiles = true;

            if (item?.caminho) {
                this.setPastaSelected(item);
            }

            axios
                .post(`api/dashboard/get/arquivos`, {
                    path: this.pathCurrent || "/",
                })
                .then((response) => {

                    
                    if (this.isPathBloqueado(this.pathCurrent)) {
                        this.bloquearAcessoPasta();
                        return;
                    }

                    this.arquivos = response.data;
                })
                .finally(() => {
                    this.loadFiles = false;
                });
        },

        getFolders(path) {
            axios
                .post(`api/dashboard/get/arquivos`, { path: path || "/" })
                .then((response) => {
                    this.arquivos = response.data;
                    this.arquivosTemp = response.data;
                })
                .finally(() => {
                    this.loadFiles = false;
                });
        },

        getArvore() {
            axios
                .post(`api/dashboard/get/arquivos`, { path: this.pathRoot })
                .then((response) => {
                    this.arquivosTemp = response.data;
                })
                .finally(() => {
                    this.loadFiles = false;
                });
        },

        deleteFile(anexo) {

            swal.fire({
                title: "Tem certeza?",
                text: "Você não poderá recuperar depois de apagado!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, excluir!",
                cancelButtonText: "Cancelar",
            }).then((result) => {

                if (result.isConfirmed) {

                    axios
                        .post(
                            `api/dashboard/delete/arquivo/GerenciadorArquivo`,
                            { item: anexo }
                        )
                        .then(() => {
                            this.loadAll(this.pathCurrent);
                        });
                }
            });
        },

        OpenRenomear(anexo) {
            this.anexoSelected = anexo;
            this.$bvModal.show("renomear-pasta");
        },

        buscar() {

            if (this.search) {

                this.arquivos = this.arquivos.filter((item) => {
                    return item.nome
                        .toLowerCase()
                        .includes(this.search.toLowerCase());
                });

            } else {
                this.arquivos = this.arquivosTemp;
            }
        },

        handler(e) {
            e.preventDefault();
        },
    },
};
</script>